import { SEO } from "../components/shared/SEO";
import { PageHeader } from "../components/shared/PageHeader";
import { Reveal, ImageReveal } from "../components/shared/Reveal";
import { Pillars, MethodTimeline, CTABand } from "../components/shared/Sections";
import { ABOUT, IMAGES } from "../content/site";

export default function ChiSiamo() {
  return (
    <>
      <SEO title="Chi Siamo | Home Haven Real Estate Development" description="Scopri Home Haven Srl, società di sviluppo e valorizzazione immobiliare con sede a Messina: visione, metodo e competenze al servizio dei progetti." image={IMAGES.detail2} />
      <PageHeader eyebrow="Chi siamo — Real Estate. Visione. Valore." title="Una visione concreta dello sviluppo immobiliare" image={IMAGES.detail2} text={ABOUT.paragraphs[0]} />

      <section className="section bg-cream">
        <div className="container-hh grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <Reveal className="lg:col-span-6">
            <p className="lead">{ABOUT.paragraphs[1]}</p>
            <p className="lead mt-6">{ABOUT.paragraphs[2]}</p>
            <p className="font-serif italic text-2xl md:text-3xl font-light mt-12 text-ink">Un'azienda giovane, imprenditoriale, orientata alla trasformazione e alla creazione di valore.</p>
          </Reveal>
          <div className="lg:col-span-6 grid grid-cols-2 gap-6">
            <ImageReveal src={IMAGES.living} alt="Interno contemporaneo" className="aspect-[3/4]" />
            <ImageReveal src={IMAGES.detail1} alt="Dettaglio architettonico" className="aspect-[3/4] mt-16" />
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container-hh">
          <Reveal className="mb-16"><div className="eyebrow mb-6">Il nostro approccio</div><h2 className="h-section">Tre verbi. Un metodo.</h2></Reveal>
          <Pillars />
        </div>
      </section>

      <section className="section bg-cream">
        <div className="container-hh">
          <Reveal className="mb-20"><div className="eyebrow mb-6">Il nostro metodo</div><h2 className="h-section max-w-3xl">Dalla ricerca dell'opportunità alla valorizzazione.</h2></Reveal>
          <MethodTimeline />
        </div>
      </section>

      <CTABand dark eyebrow="Progetti" title="Scopri le operazioni che abbiamo sviluppato." primary={{ to: "/progetti", label: "Vai ai progetti", testId: "about-cta-progetti" }} secondary={{ to: "/contatti", label: "Parliamone", testId: "about-cta-contatti" }} />
    </>
  );
}
